import * as api from "../Api";

export const getDefaultHistory = () => async (dispatch) => {
  try {
    const { data } = await api.getStockHistoryDefault();
    dispatch({ type: "GET_HISTORY_DEFAULT", payload: data });
  } catch (error) {}
};
